// @ts-nocheck
import { FormEvent, useEffect, useRef, useState } from "react";
import { Bell, Download, Plus, RefreshCw, Upload } from "lucide-react";
import { request } from "./FunctionalApp";
async function api(path: string, init: RequestInit = {}) {
  const r = await request(path, init);
  if ((r.headers.get("content-type") || "").includes("text/csv")) return r;
  if (!r.ok) {
    const x = await r.json().catch(() => ({}));
    throw new Error(String(x.error || "Unable to save").replaceAll("_", " "));
  }
  return r.json();
}
const post = (p: string, b: any) =>
  api(p, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(b),
  });
export function AssetWorkspace() {
  const [data, setData] = useState<any>({ assets: [] }),
    [show, setShow] = useState(false),
    [history, setHistory] = useState<any>(null),
    [message, setMessage] = useState("");
  async function load() {
    setData(await api("/api/cmms/assets"));
  }
  useEffect(() => {
    load();
  }, []);
  async function importCsv(file: File) {
    const lines = (await file.text()).split(/\r?\n/).filter(Boolean),
      headers = lines
        .shift()!
        .split(",")
        .map((x) => x.trim());
    const rows = lines.map((line) =>
      Object.fromEntries(
        line
          .split(",")
          .map((v, i) => [headers[i], v.trim().replace(/^"|"$/g, "")]),
      ),
    );
    const x = await post("/api/cmms/assets/import", { rows });
    setMessage(`${x.imported} assets imported`);
    load();
  }
  return (
    <>
      <div className="func-heading">
        <div>
          <h1>Asset hierarchy</h1>
          <p>
            Create maintainable assets and import an Agility-compatible CSV
            register.
          </p>
        </div>
        {data.canManage ? (
          <div className="asset-tools">
            <label className="func-button">
              <Upload />
              Import CSV
              <input
                type="file"
                accept=".csv,text/csv"
                hidden
                onChange={(e) =>
                  e.target.files?.[0] && importCsv(e.target.files[0])
                }
              />
            </label>
            <button onClick={() => setShow(!show)}>
              <Plus />
              New asset
            </button>
          </div>
        ) : null}
      </div>
      {message ? <div className="func-admin-note">{message}</div> : null}
      {show ? (
        <AssetForm
          assets={data.assets}
          saved={() => {
            setShow(false);
            load();
          }}
        />
      ) : null}
      {history ? <AssetHistory data={history} close={() => setHistory(null)} /> : null}
      <section className="func-panel asset-tree">
        <div className="func-table-head">
          <h2>Factory assets</h2>
        </div>
        {data.assets.map((a: any) => (
          <article key={a.id}>
            <span
              style={{
                paddingLeft: `${Math.max(0, a.path.split("/").length - 2) * 18}px`,
              }}
            >
              <b>{a.name}</b>
              <small>{a.path}</small>
            </span>
            <em>{a.type}</em>
            <span>{a.external_ref || "—"}</span>
            <button className="secondary" onClick={async () => setHistory(await api(`/api/cmms/assets/${a.id}/history`))}>History</button>
          </article>
        ))}
      </section>
    </>
  );
}
function AssetHistory({data,close}:any){return <section className="func-panel"><div className="func-table-head"><div><h2>{data.asset.name}</h2><p>{data.asset.path}</p></div><button className="secondary" onClick={close}>Close</button></div><div className="func-kpis"><div className="func-kpi"><span>Work orders</span><strong>{data.orders.length}</strong></div><div className="func-kpi"><span>PPM schedules</span><strong>{data.plans.length}</strong></div><div className="func-kpi"><span>Assigned parts</span><strong>{data.parts.length}</strong></div></div><h3>Maintenance history</h3>{data.orders.length?data.orders.map((w:any)=><article key={w.id}><span><b>{w.number} · {w.title}</b><small>{new Date(w.reported_at).toLocaleDateString()} · {w.engineer_name||"Unassigned"}</small></span><em>{w.status.replaceAll("_"," ")}</em></article>):<p className="func-empty">No work-order history for this asset.</p>}<h3>Planned maintenance</h3>{data.plans.map((p:any)=><article key={p.id}><span><b>{p.name}</b><small>Next due {new Date(p.next_due_at).toLocaleDateString()}</small></span><em>{p.active?"Active":"Paused"}</em></article>)}<h3>Compatible parts</h3>{data.parts.map((p:any)=><article key={p.id}><span><b>{p.canonical_name}</b><small>{p.primary_code||"No part code"} · {p.bin_location||"No bin"}</small></span><span>{p.notes||"No assignment notes"}</span></article>)}</section>}
function AssetForm({ assets, saved }: any) {
  const [f, setF] = useState({
    name: "",
    type: "MACHINE",
    parentId: "",
    externalRef: "",
  });
  async function submit(e: FormEvent) {
    e.preventDefault();
    await post("/api/cmms/assets", f);
    saved();
  }
  return (
    <section className="func-panel simple-form">
      <h2>Create asset</h2>
      <form onSubmit={submit}>
        <label>
          Name
          <input
            required
            value={f.name}
            onChange={(e) => setF({ ...f, name: e.target.value })}
          />
        </label>
        <label>
          Type
          <select
            value={f.type}
            onChange={(e) => setF({ ...f, type: e.target.value })}
          >
            <option>SITE</option>
            <option>AREA</option>
            <option>LINE</option>
            <option>MACHINE</option>
            <option>COMPONENT</option>
          </select>
        </label>
        <label>
          Parent
          <select
            value={f.parentId}
            onChange={(e) => setF({ ...f, parentId: e.target.value })}
          >
            <option value="">Top level</option>
            {assets.map((a: any) => (
              <option key={a.id} value={a.id}>
                {a.path}
              </option>
            ))}
          </select>
        </label>
        <label>
          Asset code
          <input
            value={f.externalRef}
            onChange={(e) => setF({ ...f, externalRef: e.target.value })}
          />
        </label>
        <button>Create asset</button>
      </form>
    </section>
  );
}
export function InventoryWorkspace() {
  const [data, setData] = useState<any>({ parts: [] }),
    [show, setShow] = useState(false),
    [relationships, setRelationships] = useState<any>(null),
    [message, setMessage] = useState("");
  async function load() {
    setData(await api("/api/cmms/inventory"));
  }
  useEffect(() => {
    load();
  }, []);
  async function movement(part: any, event: string) {
    const quantity = prompt(`${event} quantity for ${part.canonical_name}`);
    if (!quantity) return;
    const note = prompt("Movement note") || "";
    try {
      await post(`/api/cmms/inventory/parts/${part.id}/movements`, {
        event,
        quantity: Number(quantity),
        location: part.bin_location,
        note,
      });
      setMessage("Stock updated");
      load();
    } catch (e: any) {
      setMessage(e.message);
    }
  }
  async function code(part: any) {
    const value = prompt("Equivalent, manufacturer or supplier code");
    if (value) {
      await post(`/api/cmms/inventory/parts/${part.id}/codes`, {
        code: value,
        kind: "EQUIVALENT",
      });
      load();
    }
  }
  return (
    <>
      <div className="func-heading">
        <div>
          <h1>Inventory and stores</h1>
          <p>
            Canonical parts, equivalent codes, bin locations and an auditable
            stock ledger.
          </p>
        </div>
        <div className="asset-tools">
          <a className="func-button" href="/api/cmms/inventory/labels.csv">
            <Download />
            Brother P-touch CSV
          </a>
          {data.canManage ? (
            <button onClick={() => setShow(!show)}>
              <Plus />
              New part
            </button>
          ) : null}
        </div>
      </div>
      {message ? <div className="func-admin-note">{message}</div> : null}
      {show ? (
        <PartForm
          saved={() => {
            setShow(false);
            load();
          }}
        />
      ) : null}
      {relationships ? <PartRelationships data={relationships} close={() => setRelationships(null)} reload={async(id:string)=>setRelationships(await api(`/api/cmms/inventory/parts/${id}/relationships`))} /> : null}
      <section className="func-panel inventory-list">
        <div className="func-table-head">
          <h2>Parts register</h2>
        </div>
        {data.parts.map((p: any) => (
          <article key={p.id}>
            <span>
              <b>{p.canonical_name}</b>
              <small>
                {p.manufacturer || "No manufacturer"} ·{" "}
                {p.primary_code || "No primary code"}
              </small>
              <small>{p.codes || "No equivalents recorded"}</small>
            </span>
            <span>
              <b>{p.stock}</b>
              <small>Reorder at {p.reorder_point}</small>
            </span>
            <span>
              <b>{p.bin_location || "No bin"}</b>
              <small>{p.obsolete ? "Obsolete" : "Active"}</small>
            </span>
            {data.canManage ? (
              <div>
                <button onClick={() => movement(p, "RECEIPT")}>Receive</button>
                <button onClick={() => movement(p, "ISSUE")}>Issue</button>
                <button onClick={() => movement(p, "RETURN")}>Return</button>
                <button onClick={() => movement(p, "JOB_SHELF")}>
                  Job shelf
                </button>
                <button onClick={() => code(p)}>Add equivalent</button>
                <button onClick={async () => setRelationships(await api(`/api/cmms/inventory/parts/${p.id}/relationships`))}>Machines &amp; supersession</button>
              </div>
            ) : null}
          </article>
        ))}
      </section>
    </>
  );
}
function PartRelationships({data,close,reload}:any){const[assetId,setAssetId]=useState(""),[notes,setNotes]=useState("");async function assign(e:FormEvent){e.preventDefault();await post(`/api/cmms/inventory/parts/${data.part.id}/assets`,{assetId,notes});setAssetId("");setNotes("");reload(data.part.id)}async function supersede(id:string){await api(`/api/cmms/inventory/parts/${data.part.id}/supersession`,{method:"PUT",headers:{"content-type":"application/json"},body:JSON.stringify({supersededBy:id||null,obsolete:Boolean(id)})});reload(data.part.id)}return <section className="func-panel"><div className="func-table-head"><div><h2>{data.part.canonical_name}</h2><p>Machine compatibility and replacement chain</p></div><button className="secondary" onClick={close}>Close</button></div><form className="simple-form" onSubmit={assign}><label>Compatible machine<select required value={assetId} onChange={e=>setAssetId(e.target.value)}><option value="">Choose asset…</option>{data.assets.map((a:any)=><option key={a.id} value={a.id}>{a.path}</option>)}</select></label><label>Assignment notes<input value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Drive end only, requires adaptor…"/></label><button>Assign part</button></form><div>{data.assignments.map((a:any)=><article key={a.id}><span><b>{a.path}</b><small>{a.notes||"No notes"}</small></span></article>)}</div><label>Superseded by<select value={data.part.superseded_by||""} onChange={e=>supersede(e.target.value)}><option value="">Current part — no replacement</option>{data.catalog.map((p:any)=><option key={p.id} value={p.id}>{p.canonical_name} {p.primary_code?`(${p.primary_code})`:""}</option>)}</select></label>{data.part.superseded_by_name?<p>This part is obsolete. Use <b>{data.part.superseded_by_name}</b>.</p>:null}</section>}
function PartForm({ saved }: any) {
  const [f, setF] = useState({
    canonicalName: "",
    description: "",
    manufacturer: "",
    primaryCode: "",
    binLocation: "",
    reorderPoint: 0,
  });
  async function submit(e: FormEvent) {
    e.preventDefault();
    await post("/api/cmms/inventory/parts", f);
    saved();
  }
  return (
    <section className="func-panel simple-form">
      <h2>Create canonical part</h2>
      <form onSubmit={submit}>
        <label>
          Part name
          <input
            required
            value={f.canonicalName}
            onChange={(e) => setF({ ...f, canonicalName: e.target.value })}
          />
        </label>
        <label>
          Manufacturer
          <input
            value={f.manufacturer}
            onChange={(e) => setF({ ...f, manufacturer: e.target.value })}
          />
        </label>
        <label>
          Primary code
          <input
            value={f.primaryCode}
            onChange={(e) => setF({ ...f, primaryCode: e.target.value })}
          />
        </label>
        <label>
          Bin location
          <input
            value={f.binLocation}
            onChange={(e) => setF({ ...f, binLocation: e.target.value })}
          />
        </label>
        <label>
          Reorder point
          <input
            type="number"
            min="0"
            value={f.reorderPoint}
            onChange={(e) =>
              setF({ ...f, reorderPoint: Number(e.target.value) })
            }
          />
        </label>
        <label>
          Description
          <input
            value={f.description}
            onChange={(e) => setF({ ...f, description: e.target.value })}
          />
        </label>
        <button>Create part</button>
      </form>
    </section>
  );
}
export function ReportsWorkspace() {
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    api("/api/cmms/reports").then(setData);
  }, []);
  if (!data) return <p>Loading reports…</p>;
  const cards = [
    ["Total work orders", data.total],
    ["Active work orders", data.active],
    ["Completed", data.completed],
    [
      "Average resolution",
      data.avg_resolution_minutes ? `${data.avg_resolution_minutes} min` : "—",
    ],
    ["Downtime", `${data.downtime_minutes} min`],
    ["Temporary fixes", data.temporary_fixes],
    ["PPMs due", data.due],
    ["PPMs overdue", data.overdue],
    ["Low-stock parts", data.low_stock],
    ["Open helpdesk tickets", data.open_tickets],
  ];
  return (
    <>
      <div className="func-heading">
        <div>
          <h1>Maintenance reports</h1>
          <p>
            Operational workload, downtime, PPM compliance and stores
            exceptions.
          </p>
        </div>
        <a className="func-button" href="/api/exports/complete">
          <Download />
          Complete export
        </a>
      </div>
      <div className="report-grid">
        {cards.map(([name, value]) => (
          <div className="func-kpi" key={name}>
            <span>{name}</span>
            <strong>{value ?? 0}</strong>
          </div>
        ))}
      </div>
    </>
  );
}
export function NotificationWorkspace() {
  const [items, setItems] = useState<any[]>([]),
    [permissionState, setPermission] = useState(
      typeof Notification === "undefined"
        ? "unsupported"
        : Notification.permission,
    ),
    seen = useRef(new Set<string>());
  async function load() {
    const next = await api("/api/notifications");
    setItems(next);
    if (Notification.permission === "granted")
      for (const n of next) {
        if (!seen.current.has(n.id) && !n.read_at)
          new Notification(n.title, { body: n.body, tag: n.id });
        seen.current.add(n.id);
      }
  }
  useEffect(() => {
    load();
    const timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, []);
  async function enable() {
    const p = await Notification.requestPermission();
    setPermission(p);
    if (p === "granted") load();
  }
  return (
    <>
      <div className="func-heading">
        <div>
          <h1>Notifications</h1>
          <p>Breakdowns, escalations, overdue maintenance and stores alerts.</p>
        </div>
        {permissionState !== "granted" && permissionState !== "unsupported" ? (
          <button onClick={enable}>
            <Bell />
            Enable browser notifications
          </button>
        ) : null}
      </div>
      <section className="func-panel notification-list">
        {items.map((n) => (
          <button
            key={n.id}
            className={n.read_at ? "read" : ""}
            onClick={async () => {
              await post(`/api/notifications/${n.id}/read`, {});
              load();
            }}
          >
            <Bell />
            <span>
              <b>{n.title}</b>
              <p>{n.body}</p>
              <small>{new Date(n.created_at).toLocaleString()}</small>
            </span>
          </button>
        ))}
        {!items.length ? (
          <p className="func-empty">No notifications yet.</p>
        ) : null}
      </section>
    </>
  );
}
